<template>
    <DashboardWidgetAnalisiReddituale class="widget-analisi-reddituale-previsionale" title="Analisi Reddituale Previsionale" :values="values" />
</template>

<script>

export default {
  components: {
    DashboardWidgetAnalisiReddituale: () => import('./DashboardWidgetAnalisiReddituale.vue'),
  },
  props: {
    values: {
      type: Array,
      default: null,
    },
  },
};

</script>
